// extracted by mini-css-extract-plugin
module.exports = {"container":"_custombadge_container__2APIB","success":"_custombadge_success__22kG1","error":"_custombadge_error__2BCLk","info":"_custombadge_info__3KfiH"};